import { format } from "date-fns";

// Pure derivation (no side effects) shared by useTaskReminders and any page
// that needs to highlight overdue / due-today tasks inline. Kept as plain
// string comparison on "yyyy-MM-dd" (both due_date and "today" use the same
// format) to avoid timezone edge cases from parsing dates as UTC midnight.
export function getReminderBuckets(tasks) {
  const todayStr = format(new Date(), "yyyy-MM-dd");
  const overdueTasks = tasks.filter((tk) => !tk.completed && tk.due_date && tk.due_date < todayStr);
  const dueTodayTasks = tasks.filter((tk) => !tk.completed && tk.due_date === todayStr);
  return { overdueTasks, dueTodayTasks, reminderCount: overdueTasks.length + dueTodayTasks.length };
}
